import React from 'react';
import { Link } from 'react-router-dom';
import BackgroundImage from '../../../assets/image/Cityscape-and-Boat.jpg'; // Replace with the actual path to your image

function Last() {
  return (
    <>
      <section 
        className="cta-one" 
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="cta-one-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="cta-one-content text-center">
                  <h2 className="section-title text-white">
                    It’s a Great way to Love and
                    <br /> Support your City
                  </h2>
                  <Link to="/contact" className="btn btn-primary"> Start Donating Now </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Last;
